import React, { useContext } from 'react';
import styled from 'styled-components';

import Divider from 'components/shared/Divider';
import Icon from 'components/shared/Icon';
import IsOwner from 'components/shared/IsOwner';

import { ModalContext } from 'components/shared/context/ModalContextProvider';

import edit from 'images/edit.svg';

import Type from 'schema/type';

interface TypeBoxProps {
  type: Type;
}

const TypeBoxContainer = styled.div`
  display: grid;
  grid-template-columns: 4fr 6fr;
  gap: 20px;

  align-items: top;
`;

const TypeText = styled.div`
  font-family: 'CircularStd-Medium';
  font-size: 15px;

  line-height: 24px;
`;

const TypeBoxContainerRightSection = styled.div`
  display: flex;
  align-items: top;
  gap: 20px;

  justify-self: flex-end;
`;

const TypeCost = styled.div`
  color: #a3a3a3;
`;

const TypeBox: React.FC<TypeBoxProps> = ({ type }) => {
  const { openEditTypeModal } = useContext(ModalContext);

  return (
    <>
      <Divider />
      <TypeBoxContainer>
        <TypeText>{type.name}</TypeText>
        <TypeBoxContainerRightSection>
          <TypeText>
            <span>P {type.price}</span>
            {type.measurementUnit && (
              <span>&nbsp;per {type.measurementUnit}</span>
            )}
            <IsOwner>
              {(type.cost || type.cost === 0) && (
                <TypeCost>P {type.cost}</TypeCost>
              )}
            </IsOwner>
          </TypeText>
          <IsOwner>
            <Icon
              src={edit}
              onClick={() => {
                openEditTypeModal?.(type);
              }}
            />
          </IsOwner>
        </TypeBoxContainerRightSection>
      </TypeBoxContainer>
    </>
  );
};

export default TypeBox;
